import { switchAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle } = createMultiStyleConfigHelpers(switchAnatomy.keys);

const baseStyle = definePartsStyle({
  track: {
    bg: "grey.150",
    _checked: {
      bg: "pinkFlink.500",
    },
  },
});

const positiveNegativeStyle = definePartsStyle({
  track: {
    bg: "red.500",
    _checked: {
      bg: "veggie.400",
    },
  },
});

export const Switch = {
  baseStyle,
  variants: {
    default: baseStyle,
    positiveNegative: positiveNegativeStyle,
  },
};
